<!--  without image -->

@if (block(); as block) {
  <article class="container">
    <div class="section-inset-y text-bg-primary p-4 p-md-5 py-md-7 card cta-card" [class.has--overlay]="block.image?.url && block.intro">
      @if (block.image?.url) {
        <fstr-image
          class="card-img-background card-img"
          [image]="block.image!"
          [fill]="true"
          [colSpan]="{
            sm: 8,
          }"
        ></fstr-image>
      }

      <div class="row gutter-y-3 position-relative z-2">
        @if ((block.title || block.subtitle) && !block.hideTitle) {
          <header class="" [ngClass]="block.intro ? 'col-md-12' : 'mx-auto text-center'">
            @if (block.subtitle) {
              <strong class="fs-body-md fw-normal mb-2 d-inline-block w-100">{{ block.subtitle }}</strong>
            }
            @if (block.title) {
              <h2 class="" [ngClass]="block.intro ? 'h3 mb-0' : 'h1 mb-2'">
                {{ block.title }}
              </h2>
            }
          </header>
        }

        @if (hasContent$()) {
          <main class="d-flex flex-column gap-4" [ngClass]="block.intro ? 'col-md-12' : 'text-center pt-2'">
            @if (block.intro) {
              <div
                class="markdown-content"
                fstrDynamicContent
                [innerHTML]="block.intro | resizeHtmlImages | stripEmbed: cookiePreferences() | safe"
              ></div>
            }

            @if (block.button?.url) {
              <fstr-link
                [ngClass]="block.intro ? '' : 'd-block mx-auto'"
                [button]="block.button!"
                [cssClasses]="'button button--accent'"
              ></fstr-link>
            }
          </main>
        }
      </div>
    </div>
  </article>
}
